import type { FolderPathEntry } from './schemas'

/** Separator between breadcrumb names, matching the design's `Bills / Medical Bills`. */
const kPathSeparator = ' / '

/**
 * The location line for a suggestion row.
 *
 * Suggestions show the **whole** path, unlike the results table, which shows only the immediate
 * parent. Rooted at the drive the item lives in when the matter has one connected; `folder_path`
 * excludes the matter root, so an item sitting there falls back to the matter name over a blank.
 */
export function formatSuggestionPath(folderPath: readonly FolderPathEntry[], matterName: string, rootLabel: string | null): string {
  const segments = [...(rootLabel ? [rootLabel] : []), ...folderPath.map((entry) => entry.name)]

  return segments.length > 0 ? segments.join(kPathSeparator) : matterName
}
